import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Button from '@mui/material/Button';
import { RESUME_EVALUATION_ROUTER_PATH } from '@/constants/router-path';
import { trackClickEvent } from '@/utils/site-track';
import BgImage from '@/assets/company-detail/bg.png';

const MarketingBanner = (props: {
  letter: { title: string; subTitle: string };
}) => {
  const {
    letter: { title, subTitle },
  } = props;

  return (
    <div
      data-observer-id="marketing_banner_evaluation"
      data-ele-group="marketing_banner_evaluation"
      data-ele-id={`banner_${subTitle}`}
      className="rounded-lg p-5.5 text-center mb-6 relative overflow-hidden"
    >
      <Image src={BgImage} alt="" fill priority />
      <p className="text-2xl font-semibold text-web-black-100">{title}</p>
      <p className="text-base text-web-black-100 leading-7 max-w-[442px] mx-auto text-left break-all mt-4 mb-6">
        {subTitle}
      </p>
      <Button
        className="w-full h-[45px] !font-semibold !tracking-[1px] tablet:w-[220px]"
        variant="contained"
        color="primary"
        LinkComponent={Link}
        href={RESUME_EVALUATION_ROUTER_PATH}
        onClick={trackClickEvent}
      >
        立即诊断
      </Button>
    </div>
  );
};

export default MarketingBanner;
